module.exports = __webpack_public_path__ + "img/e296304c5c4ae4acfdfe5f0a3f3a4cc0.png";